module.exports = __webpack_public_path__ + "templates.image-banner-display-a7a166b9.html";